import { cs } from "../../utils/currency";
import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

interface OrdersBySourceDatum {
  label: string;
  orders: number;
  revenue: number;
}

interface OrdersBySourceChartProps {
  data: OrdersBySourceDatum[];
}

const formatRevenue = (value: number) => `${cs()}${Number(value).toFixed(2)}`;

const OrdersBySourceChart: React.FC<OrdersBySourceChartProps> = ({ data }) => {
  return (
    <div className="h-[280px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 5, right: 16, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="label" tick={{ fontSize: 12 }} />
          <YAxis yAxisId="left" tick={{ fontSize: 12 }} allowDecimals={false} />
          <YAxis
            yAxisId="right"
            orientation="right"
            tick={{ fontSize: 12 }}
            tickFormatter={formatRevenue}
          />
          <Tooltip
            formatter={(value, name) =>
              name === "Revenue"
                ? [formatRevenue(Number(value)), name]
                : [Number(value), name]
            }
          />
          <Legend />
          <Bar
            yAxisId="left"
            dataKey="orders"
            name="Orders"
            fill="#2563eb"
            radius={[6, 6, 0, 0]}
          />
          <Bar
            yAxisId="right"
            dataKey="revenue"
            name="Revenue"
            fill="#60a5fa"
            radius={[6, 6, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OrdersBySourceChart;
